import React from 'react';
import env from 'env';
import { useRouter } from 'components';
import { getProductEditModel } from './productEditFormModel';
import { usePost } from 'components';
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';
import { SiteLink } from 'components';

/** ProductType.LiveFeed value — send when creating from "Add live stream". */
const LIVE_FEED_PRODUCT_TYPE = 4;
/** ProductType.Dartfish value — send when creating from "Add Dartfish product". */
const DARTFISH_PRODUCT_TYPE = 5;

export function ProductNew(props) {
  const { query } = useRouter();
  const isLiveFeed = (query.type || '').toLowerCase() === 'livefeed';
  const isDartfish = (query.type || '').toLowerCase() === 'dartfish';
  const initialData = isLiveFeed
    ? { productName: 'New live stream' }
    : isDartfish
    ? { productName: 'New Dartfish product' }
    : {};
  const model = getProductEditModel(initialData);

  return <ProductEditForm model={model} isLiveFeed={isLiveFeed} isDartfish={isDartfish} />;
}

function ProductEditForm({ model, isLiveFeed, isDartfish }) {
  const form = useForm(model, {});
  const post = usePost();
  const { Redirect } = useRouter();

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };
      if (isLiveFeed) {
        value.productType = LIVE_FEED_PRODUCT_TYPE;
      } else if (isDartfish) {
        value.productType = DARTFISH_PRODUCT_TYPE;
      }
      post.send(env.apiBase + '/api/productAdmin/createProduct', value);
    });
  }

  if (post.done()) {
    const productId = post.response.results.productId;
    return <Redirect to={`/admin/product/${productId}`} />;
  }

  const cancelTo = isLiveFeed ? '/admin/live-feeds' : isDartfish ? '/admin/dartfish' : '/admin/products';

  return (
    <div className="editor productEditor">
      <h1>{isLiveFeed ? 'New live stream' : isDartfish ? 'New Dartfish product' : 'New Product'}</h1>

      <section>
        <div className="row">
          <div className="col-md-9">{render('productName')}</div>
        </div>
        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Create</Button>
            <SiteLink className="btn btn-outline-dark" to={cancelTo}>Cancel</SiteLink>
          </div>
        </div>
      </section>
    </div>
  );
}